import React from "react";
import RegistrationComponent from "../components/RegistrationComponent";

function RegistrationPage() {
  return (
    <>
      <RegistrationComponent />
    </>
  );
}

export default RegistrationPage;
